import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getSubscriptionPagePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, "/fathers-family-club");
}
